import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const BoostFailureAlert = ({ onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          padding: 3,
        }}
        elevation={8}
      >
        <CardContent>
          <RocketLaunchIcon
            sx={{
              fontSize: 60,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Boost Failed 
          </Typography>

          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={onClose}
            sx={{ borderRadius: 3, paddingY: 1, fontWeight: 600, mt: 2 }}
          >
            OK
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BoostFailureAlert;